import styled from 'styled-components';

const GetTouchContactStyle = styled.div`
	--titleDistanceT: var(--sp15x);
	--titleDistanceB: var(--sp10x);
	--distanceStar: var(--sp2x);
	--distanceButton: var(--sp4x);
	--itemInfoPadTB: var(--sp8x);
	--itemInfoPadLR: var(--sp5x);
	--borderRadius: var(--sp4x);
	--sizeIcon: var(--sp6x);
	--distanceDescription: var(--sp4x);
	--distanceIcon: var(--sp3x);
	--distanceContactGap: var(--sp3x);
	--contactTitleDistance: var(--sp1x);
	--distancePhones: var(--sp1-5x);
	--distanceSubtitleDescriptionBottom: var(--sp4x);

	.title {
		margin-top: var(--titleDistanceT);
		margin-bottom: var(--titleDistanceB);
	}

	.item-info {
		padding: var(--itemInfoPadTB) var(--itemInfoPadLR);
		height: 100%;
		border: 1px solid var(--neutral600);
		border-radius: var(--borderRadius);

		img {
			object-fit: contain;
		}
	}

	.icon-wrapper {
		--proportion: var(--sizeIcon);
		width: var(--sizeIcon);
	}

	.distance-subtitle {
		margin-top: var(--distanceIcon);
		margin-bottom: var(--distanceDescription);
	}

	.wrapper-delivery-info {
		display: flex;
		flex-direction: column;
		gap: var(--distanceContactGap);

		.title-contact {
			margin-bottom: var(--contactTitleDistance);
		}
	}

	.wrapper-phones {
		display: flex;
		flex-direction: column;
		gap: var(--distancePhones);
	}

	.description-subtitle {
		margin-bottom: var(--distanceSubtitleDescriptionBottom);
	}

	.hover-clickable {
		width: fit-content;
		transition: all var(--trTime) ease-out;
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.hover-clickable {
				&:hover {
					color: var(--pink1000);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeIcon: var(--sp5x);
		--distanceDescription: var(--sp3x);
		--distanceIcon: var(--sp4x);
		--distancePhones: var(--sp2x);
		--distanceSubtitleDescriptionBottom: var(--sp3x);
		--titleDistanceT: var(--sp10x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceButton: var(--sp3x);
		--borderRadius: var(--sp3x);
		--itemInfoPadTB: var(--sp6x);
		--itemInfoPadLR: var(--sp5x);
		--distanceDescription: var(--sp2x);
		--distanceIcon: var(--sp3x);
		--distanceContactGap: var(--sp2x);
		--distancePhones: var(--sp1x);
		--distanceSubtitleDescriptionBottom: var(--sp2x);
		--titleDistanceT: var(--sp9x);
		--titleDistanceB: var(--sp7x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--itemInfoPadTB: var(--sp5x);
		--itemInfoPadLR: var(--sp4x);
		--titleDistanceT: var(--sp8x);
		--titleDistanceB: var(--sp4x);
		--sizeIcon: var(--sp4x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceDescription: var(--sp3x);
		--distanceIcon: var(--sp3x);
		--itemInfoPadTB: var(--sp4x);
		--itemInfoPadLR: var(--sp3x);
		--itemInfoPadTB: var(--sp4x);
		--itemInfoPadLR: var(--sp3x);
		--titleDistanceT: var(--sp7x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--borderRadius: var(--sp2x);
		--distanceDescription: var(--sp2x);
		--distanceIcon: var(--sp2x);
		--itemInfoPadTB: var(--sp3x);
		--itemInfoPadLR: var(--sp3x);
		--titleDistanceT: var(--sp4x);
		--titleDistanceB: var(--sp6x);

		.wrapper-info {
			.row {
				row-gap: var(--gutter);
			}
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceStar: var(--sp1-5x);
		--itemInfoPadTB: var(--sp4x);
		--itemInfoPadLR: var(--sp3x);
		--distanceContactGap: var(--sp1-5x);
		--itemInfoPadTB: var(--sp4x);
		--itemInfoPadLR: var(--sp3x);
		--titleDistanceT: var(--sp6x);
		--titleDistanceB: var(--sp4x);

		.wrapper-info {
			.row {
				row-gap: var(--gutter);
			}
		}
	}
`;
export default GetTouchContactStyle;
